import React from 'react';
import Drawer from "@mui/material/Drawer/Drawer";
import List from "@mui/material/List/List";
import NotificationListItem from "./NotificationListItem";
import Divider from "@mui/material/Divider/Divider";
import ListItem from "@mui/material/ListItem/ListItem";
import IconButton from "@mui/material/IconButton/IconButton";
import Tooltip from "@mui/material/Tooltip/Tooltip";
import Typography from "@mui/material/Typography/Typography";
import CancelIcon from "@mui/icons-material/Cancel";
import { Nullable } from '../../models/common/Nullable';
import { Notification } from '../../models/users/Notification';
import { markUserNotificationAsRead } from '../../actions/user/NotificationActions';
import { LanguageProp} from '../../config/LanguageConfig';

/**
 * typescript
 */
interface NotificationDrawerProps extends LanguageProp {
    notifications: Nullable< Notification[] >
    onClose(): void
    markNotificationAsRead: typeof markUserNotificationAsRead
    isOpen: boolean
}

class NotificationDrawer extends React.Component<NotificationDrawerProps, {}> {

    getNotificationList() {
        const { language } = this.props;
        let comps = [];
        // add default ListItem
        comps.push(
            <ListItem className="nav-drawer-header" key={'notification-drawer-headline'}>
                <div style={{ 'display': 'flex', alignItems: 'center', justifyContent: 'center' }}>
                    <Tooltip title={language.common.closeButton.tooltipText}>
                        <IconButton
                            aria-haspopup="true"
                            aria-label={language.common.closeButton.tooltipText}
                            style={{ 'color': 'white' }}
                            onClick={() => this.props.onClose()}
                        >
                            <CancelIcon />
                        </IconButton>
                    </Tooltip>
                    <Typography variant="h6" style={{ 'color': 'white' }}>
                        {language.notification.unreadNotificationTitle}
                    </Typography>
                </div>
            </ListItem>
        );
        comps.push( <Divider key={"notify-drawer-headline-divider"} /> );

        if( this.props.notifications !== null ) {
            this.props.notifications.forEach(notify => {
                comps.push(
                    <NotificationListItem
                        notification={ notify }
                        markAsRead={ this.props.markNotificationAsRead }
                        key={ "notification_"+ notify.id.rawValue }
                        closeDrawer={this.props.onClose}
                        language={language}
                    />
                );
                comps.push( <Divider key={"notify-divider-"+ notify.id.rawValue } /> );
            });
        } else {
            comps.push(
                <ListItem key={"notify-no-unread"}>
                        <Typography>
                            { language.notification.noUnreadNotifications }
                        </Typography>
                </ListItem>
            );
            comps.push( <Divider key={"notify-no-unread"} /> );
        }

        return comps;
    }

    render() {
        return (
            <Drawer anchor="right" open={this.props.isOpen} onClose={this.props.onClose}>
                <List style={{ paddingTop: 0 }}>
                    {this.getNotificationList()}
                </List>
            </Drawer>
        );
    }
}

export default NotificationDrawer;